import * as AppTypes from './types';

/* App  */
export const logIn = () => ({
  type: AppTypes.LOG_IN,
});

export const logOut = (data) => ({
  type: AppTypes.LOG_OUT,
  data,
});

export const setAppCurrency = (data) => ({
  type: AppTypes.SET_APP_CURRENCY,
  data,
});

export const setAppLanguage = (data) => ({
  type: AppTypes.SET_APP_LANGUAGE,
  data,
});

/* User  */
export const getUserData = () => ({
  type: AppTypes.GET_USER,
});

export const updateUserData = (data) => ({
  type: AppTypes.UPDATE_USER_DATA,
  data,
});

export const updateUserAgreements = (data) => ({
  type: AppTypes.UPDATE_USER_AGREEMENTS,
  data,
});

/* FAQ's */

export const getFAQsCategories = () => ({
  type: AppTypes.GET_FAQ_CATEGORIES,
});

export const getFAQs = () => ({
  type: AppTypes.GET_FAQ_QUESTIONS,
});

export const getMostSearchedFAQsTerms = (limitTerms) => ({
  type: AppTypes.GET_MOST_SEARCHED_FAQ,
  limitTerms,
});

export const getSearchedFAQs = (searchedTerm) => ({
  type: AppTypes.GET_SEARCHED_FAQ,
  searchedTerm,
});

export const getFAQsAnswer = (faqId) => ({
  type: AppTypes.GET_FAQ_ANSWER,
  faqId,
});

/* Borrower dashboard  */
export const getBorrowerDashboardData = () => ({
  type: AppTypes.GET_BORROWER_DASHBOARD_DATA,
});

/* Investor dashboard  */
export const getInvestorDashboardData = () => ({
  type: AppTypes.GET_INVESTOR_DASHBOARD_DATA,
});

/* Investor instruction */
export const sendInvestorInstruction = (data) => ({
  type: AppTypes.SEND_INVESTOR_INSTRUCTION,
  data,
});

/* Investor investments  */
export const getInvestorInvestments = (data) => ({
  type: AppTypes.GET_INVESTOR_INVESTMENTS,
  data,
});

export const getInvestorOffers = (data) => ({
  type: AppTypes.GET_INVESTOR_OFFERS,
  data,
});

export const setInvestorOffers = (payload) => ({
  type: AppTypes.SET_INVESTOR_OFFERS,
  payload,
});

/* Investor secondary market  */
export const getInvestorSecondaryMarket = (data) => ({
  type: AppTypes.GET_INVESTOR_SECONDARY_MARKET,
  data,
});

/* Investor biddings */
export const getInvestorBiddings = (data) => ({
  type: AppTypes.GET_INVESTOR_BIDDINGS,
  data,
});

export const getInvestorInvestmentDetail = (data) => ({
  type: AppTypes.GET_INVESTOR_INVESTMENT_DETAIL,
  data,
});

export const getInvestorInvestmentInstruction = () => ({
  type: AppTypes.GET_INVESTOR_INVESTMENT_INSTRUCTION,
});

export const getDepositQrCodeString = (data) => ({
  type: AppTypes.GET_DEPOSIT_QR_CODE_STRING,
  data,
});

export const resetDepositQrCodeString = () => ({
  type: AppTypes.RESET_DEPOSIT_QR_CODE_STRING,
});

/* Onboarding Borrower */
export const sendPersonalInformationProcessingAgrees = (data) => ({
  type: AppTypes.SEND_PERSONAL_INFORMATION_PROCESSING_AGREES,
  data,
});

export const getBorrowerOnboardingStep = () => ({
  type: AppTypes.GET_BORROWER_ONBOARDING_STEP,
});

export const sendBorrowerOnboardingStep = (data) => ({
  type: AppTypes.SEND_BORROWER_ONBOARDING_STEP,
  data,
});

export const sendBorrowerOnboardingDocuments = (data) => ({
  type: AppTypes.SEND_BORROWER_ONBOARDING_DOCUMENTS,
  data,
});

/* Onboarding Investor */
export const getInvestorOnboardingStep = () => ({
  type: AppTypes.GET_INVESTOR_ONBOARDING_STEP,
});

export const sendInvestorOnboardingStep = (data) => ({
  type: AppTypes.SEND_INVESTOR_ONBOARDING_STEP,
  data,
});

export const sendInvestorOnboardingIdentityCards = (data) => ({
  type: AppTypes.SEND_INVESTOR_ONBOARDING_IDENTITY,
  data,
});

export const getInvestorDocumentTypes = () => ({
  type: AppTypes.GET_INVESTOR_DOCUMENT_TYPES,
});
export const getDebtorDocumentTypes = () => ({
  type: AppTypes.GET_DEBTOR_DOCUMENT_TYPES,
});

export const sellInvestmentToGuaranteeFund = (data) => ({
  type: AppTypes.SELL_INVESTOR_INVESTMENT_TO_GUARANTEE_FUND,
  data,
});

export const createInvestmentOffer = (data) => ({
  type: AppTypes.CREATE_INVESTOR_INVESTMENT_OFFER,
  data,
});

export const cancelOfferSell = (data) => ({
  type: AppTypes.CANCEL_INVESTOR_INVESTMENT_OFFER,
  data,
});

export const buySecondaryMarketOffer = (data) => ({
  type: AppTypes.BUY_OFFER_FROM_SECONDARY_MARKET,
  data,
});

export const bidSecondaryMarketOffer = (data) => ({
  type: AppTypes.BID_OFFER_FROM_SECONDARY_MARKET,
  data,
});

export const acceptBiddingOffer = (data) => ({
  type: AppTypes.ACCEPT_BIDDING,
  data,
});

export const declineBiddingOffer = (data) => ({
  type: AppTypes.DECLINE_BIDDING,
  data,
});

export const sendSms = (data) => ({
  type: AppTypes.SEND_SMS,
  data,
});
export const sendPublicSms = (data) => ({
  type: AppTypes.SEND_PUBLIC_SMS,
  data,
});
export const verifyPhoneNumber = (data) => ({
  type: AppTypes.VERIFY_PHONE_NUMBER,
  data,
});
export const verifyPhoneNumberSuccess = (data) => ({
  type: AppTypes.VERIFY_PHONE_NUMBER_SUCCESS,
  data,
});
export const verifyPhoneNumberError = (error) => ({
  type: AppTypes.VERIFY_PHONE_NUMBER_ERROR,
  error,
});

/* Requests */
export const getRequestTemplate = (data) => ({
  type: AppTypes.GET_REQUEST_TEMPLATE,
  data,
});

export const createRequest = (data) => ({
  type: AppTypes.CREATE_REQUEST,
  data,
});

/* Mailbox */
export const getMailboxEmails = () => ({
  type: AppTypes.GET_MAILBOX_EMAILS,
});

export const getMailboxSms = () => ({
  type: AppTypes.GET_MAILBOX_SMS,
});

export const getMailboxAll = () => ({
  type: AppTypes.GET_MAILBOX_ALL,
});

export const getMailboxDocuments = () => ({
  type: AppTypes.GET_MAILBOX_DOCUMENTS,
});

export const getMailboxRequests = () => ({
  type: AppTypes.GET_MAILBOX_REQUESTS,
});

export const getMailboxLetters = () => ({
  type: AppTypes.GET_MAILBOX_LETTERS,
});

/* Authorization */
export const signIn = (data) => ({
  type: AppTypes.SIGN_IN,
  data,
});

export const resendPassword = (data) => ({
  type: AppTypes.RESEND_PASSWORD,
  data,
});

export const registrationCheck = (data) => ({
  type: AppTypes.CHECK_REGISTRATION,
  data,
});

export const sendFinishRegistrationEmail = (data) => ({
  type: AppTypes.SEND_FINISH_REGISTRATION_EMAIL,
  data,
});

export const getInvestmentsForSale = (payload) => ({
  type: AppTypes.GET_INVESTMENTS_FOR_SALE,
  payload,
});

export const setInvestmentsForSale = (payload) => ({
  type: AppTypes.SET_INVESTMENTS_FOR_SALE,
  payload,
});

export const postInvestmentsForSale = (payload, onSuccess, onBadSmsCode, onError = () => {}) => ({
  type: AppTypes.POST_INVESTMENTS_FOR_SALE,
  payload,
  onSuccess,
  onBadSmsCode,
  onError,
});

export const setGlobalErrorVisibility = (visibility) => ({
  type: AppTypes.SET_GLOBAL_SERVER_ERROR_VISIBILITY,
  payload: visibility,
});

export const getUserResourcesRequest = () => ({
  type: AppTypes.GET_RESOURCES_REQUEST,
});

export const getUserResourcesSuccess = (resources) => ({
  type: AppTypes.GET_RESOURCES_SUCCESS,
  payload: resources,
});

export const getMailboxReports = () => ({
  type: AppTypes.GET_MAILBOX_REPORTS,
});

export const setMailboxReports = () => ({
  type: AppTypes.SET_MAILBOX_REPORTS,
});

export const changeMailboxReportsSubscription = (subscribed) => ({
  type: AppTypes.SET_MAILBOX_REPORTS_SUBSCRIPTION,
  payload: subscribed,
});

export const getInvestorOffersCount = () => ({
  type: AppTypes.GET_INVESTOR_OFFERS_COUNT,
});

export const setInvestorOffersCount = ({ automatic, manual }) => ({
  type: AppTypes.SET_INVESTOR_OFFERS_COUNT,
  payload: {
    automatic,
    manual,
  },
});

export const getInvestorOffersCountError = () => ({
  type: AppTypes.GET_INVESTOR_OFFERS_COUNT_ERROR,
});

/* Estimated earnings graph */
export const getEstimatedEarningsGraphData = (data) => ({
  type: AppTypes.GET_ESTIMATED_EARNINGS_GRAPH_DATA,
  data,
});

export const transferClaim = (data) => ({
  type: AppTypes.TRANSFER_CLAIM,
  data,
});
